import { useContext, useEffect, useMemo } from "react";
import getConfig from "../configs/tableConfig";
import BeelditTableHeaderActions from "@beeldit/core/components/BeelditTableHeaderActions";
import { AuthContext } from "@beeldit/user-and-access/auth/AuthContext";
import { t } from "i18next";
import useRemoveAction from "../actions/remove/useRemoveAction";
import useCreateAction from "../actions/create/useCreateAction";
import useEditAction from "../actions/edit/useEditAction";
import useListAction from "../actions/list/useListAction";
import { ListActionContext } from "../actions/list/ListActionContext";
import { Card } from "react-bootstrap";

function AddressesPage(props: any) {
  // Obtenemos la propiedad filters de props
  const { filters, formDefaultValues, maxItems } = props;
  const { tableData } = useContext(ListActionContext);

  const { user } = useContext(AuthContext);

  const {
    indexFunction,
    actionTemplate: listActionTemplate,
    setTableConfig,
  } = useListAction(user, filters);

  const { initializeFunction, actionTemplate: createActionTemplate } =
    useCreateAction(indexFunction, formDefaultValues);

  const { getFunction, actionTemplate: editActionTemplate } =
    useEditAction(indexFunction);

  const { prepareRemoveFunction, actionTemplate: removeActionTemplate } =
    useRemoveAction(indexFunction);

  /**<newActionsHooks**/

  /**
   * Table configuration definition
   */
  const memoTableConfig = useMemo(
    () =>
      getConfig({
        initializeFunction, // We pass the function to initialize a new element (used in the create button)
        indexFunction, // We pass the function to index the table
        getFunction, // We pass the function to get an element (used in the edit button)
        prepareRemoveFunction,
        /**newActionsTableConfig**/
      }),
    [initializeFunction, indexFunction, getFunction, prepareRemoveFunction]
  );

  useEffect(() => {
    setTableConfig(memoTableConfig);
  }, [memoTableConfig, setTableConfig]);

  const filteredActions = useMemo(() => {
    if (maxItems !== undefined && tableData?.elements?.length >= maxItems) {
      return memoTableConfig.actions.map((action: any) =>
        action.name === "create" ? { ...action, show: false } : action
      );
    }
    return memoTableConfig.actions;
  }, [memoTableConfig.actions, maxItems, tableData?.elements?.length]);

  return (
    <Card>
      <Card.Header>
        <Card.Title>{t("Addresses")}</Card.Title>
        <BeelditTableHeaderActions actions={filteredActions} />
      </Card.Header>

      <Card.Body>
        {listActionTemplate}
        {createActionTemplate}
        {editActionTemplate}
        {removeActionTemplate}
        {/* newTemplateActions */}
      </Card.Body>
    </Card>
  );
}

export default AddressesPage;
